import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { useActionDispatcher } from '../../hooks';
import VideoForm from './VideoForm';
import {
  getVideoRequest,
  resetCurrentVideo,
  saveVideoRequest,
} from '../../store/modules/videos/actions';
import { selectVideo } from '../../store/modules/videos/selectors';

const VideoEdit = () => {
  const dispatch = useDispatch();

  const video = useSelector(selectVideo);

  const match = useRouteMatch<{
    id: string;
  }>()!;

  const videoId = video.data?.id;
  useEffect(() => {
    const matchId = parseInt(match.params.id, 10);
    if (!videoId || matchId !== videoId) {
      dispatch(getVideoRequest(matchId));
    }
  }, [dispatch, match.params.id, videoId]);

  useEffect(() => () => {
    dispatch(resetCurrentVideo());
  }, [dispatch]);

  const saveVideo = useActionDispatcher(saveVideoRequest);

  return (
    <VideoForm
      record={video}
      onSubmit={saveVideo}
    />
  );
};

export default VideoEdit;
